import { ArrowDown } from "lucide-react";

export const PainPoints = ({ product }) => (
  <section className="bg-[#F9F6F0]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 md:py-28">
      <div className="max-w-3xl">
        <p data-reveal className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-4">
          Sound familiar?
        </p>
        <h2
          data-reveal
          className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-[#0B132B]"
        >
          The retirement math most people never see coming.
        </h2>
      </div>
      <div className="mt-10 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {product.funnel.pains.map((p, i) => (
          <div
            key={i}
            data-reveal
            data-reveal-delay={i * 0.08}
            data-testid={`pain-card-${i}`}
            className="group relative rounded-3xl bg-white border border-[#0B132B]/6 p-7 md:p-9 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0B132B]/8"
          >
            <span className="font-heading font-black text-6xl md:text-7xl leading-none tracking-tighter text-gradient-breeze opacity-30 group-hover:opacity-60 transition-opacity duration-300">
              0{i + 1}
            </span>
            <h3 className="mt-5 font-heading font-bold text-xl md:text-2xl tracking-tight text-[#0B132B] leading-snug">
              {p.title}
            </h3>
            <p className="mt-3 text-sm md:text-base text-[#334155] font-light leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>
      <a
        href="#how-it-works"
        data-reveal
        data-testid="pain-next-link"
        className="mt-10 md:mt-14 inline-flex items-center gap-3 text-[#0B132B] font-heading font-bold text-lg md:text-xl group"
      >
        <span className="w-11 h-11 rounded-full bg-[#0B132B] text-white flex items-center justify-center transition-all duration-300 group-hover:bg-[#29ABE2] animate-bounce">
          <ArrowDown size={18} />
        </span>
        {product.tag} was designed to answer all three.
      </a>
    </div>
  </section>
);
